import { useSearchParams } from "react-router-dom";
import { Box } from "@leagueplatform/genesis-core";
import { useIntl } from "@leagueplatform/locales";
import { usePageViewAnalytics } from "@leagueplatform/analytics";
import { useDocumentTitle } from "@leagueplatform/web-common";
import { Masonry } from "@leagueplatform/masonry";
import { MASONRY, PAGE_CONTENT_MAX_WIDTH } from "common/constants";
import { PageContentWrapper } from "components/page-content-wrapper.component";
import { PageHeader } from "components/page-header/page-header.component";

export const SelfCollectionActivationFormPage = () => {
  const [searchParams] = useSearchParams();
  const programId = searchParams.get("programId") ?? "";

  usePageViewAnalytics({ screen_name: "Self Collection Activation Form" });
  const { formatMessage } = useIntl();

  const title = formatMessage({ id: "STR_SELF_COLLECTION_ACTIVATION_FORM" });
  useDocumentTitle(title);

  return (
    <PageContentWrapper>
      <PageHeader variant="sub-page" mobileBand="green" headingText={title} />
      <Box css={{ maxWidth: PAGE_CONTENT_MAX_WIDTH, marginInline: "auto" }}>
        <Masonry
          rootNodeId={MASONRY.ROOT_NODE_ID_SELF_COLLECTION_ACTIVATION_FORM}
          initialQueryParams={{ programId }}
        />
      </Box>
    </PageContentWrapper>
  );
};
